import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import Debug from '@/components/Debug';
import Button from '@/ui/components/Button';
import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading';

import InsuranceDetails from './InsuranceDetails';
import InsuranceInPlaceEditor from './InsuranceInPlaceEditor';
import InsuranceSummary from './InsuranceSummary';
import type { Props } from './types';
import VOBSection from './VOBSection';

const PersonInsurancePolicy = ({ insurancePolicy }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card className="relative flex flex-col gap-4">
      <InsuranceSummary insurancePolicy={insurancePolicy} />
      <div className="flex justify-center my-2">
        <Button
          ariaLabel={`Show ${isExpanded ? 'less' : 'more'}`}
          size="xs"
          onClick={() => setIsExpanded(!isExpanded)}>
          Show {isExpanded ? 'less' : 'more'}
          <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="ml-2" />
        </Button>
      </div>
      {isExpanded && (
        <>
          <hr />
          <VOBSection insurancePolicy={insurancePolicy} />
          <hr />
          <Heading value={3} text="Insurance details" />
          <InsuranceInPlaceEditor insurancePolicy={insurancePolicy}>
            <InsuranceDetails insurancePolicy={insurancePolicy} />
          </InsuranceInPlaceEditor>
        </>
      )}
      <Debug object={insurancePolicy} />
    </Card>
  );
};
export default React.memo(PersonInsurancePolicy);
